export const equals = (n1: number, n2: number, accuracy = 1e-5) => {
  return (
    (n1 + accuracy >= n2 && n1 - accuracy <= n2) ||
    (n2 + accuracy >= n1 && n2 - accuracy <= n1)
  );
};
